import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Dispatch } from '@tmapy/redux';
import { useMessage, useSelectMessages } from '@tmapy/intl';

import {
  BtnBar,
  CtaBtn,
  Form,
  FormItem,
  Input,
  SecondaryBtn,
  Select,
  StickyFooter,
} from '@tmapy/style-guide';

import { useInput } from '../../hooks';
import type { PriceListItemsListQuery } from '../../openapi/operations/priceListItemsList';
import { PriceListItemTypesEnum } from '../../openapi/types/PriceListItemTypesEnum';
import { setPriceListItemListFilter } from '../../redux/filter/actions';

import {
  priceListMessages,
  priceListBtnMessages,
  priceListItemTypeMessages,
} from './priceListMessages';

type PriceListItemFilterProps = {
  filters: PriceListItemsListQuery;
  dispatch: Dispatch;
};

export const PriceListItemFilter: React.FC<PriceListItemFilterProps> = ({ filters, dispatch }) => {
  const formatMessage = useMessage();

  const name = useInput({
    name: 'name__icontains',
    initialValue: filters.name__icontains,
    label: formatMessage(priceListMessages.name),
  });

  const typeItems = useSelectMessages(priceListItemTypeMessages, PriceListItemTypesEnum);
  const type = useInput({
    name: 'type',
    initialValue: filters.type,
    items: typeItems,
    label: formatMessage(priceListMessages.type),
  });

  const handleClearBtnClick = useCallback(() => {
    [name, type].forEach((formItem) => formItem?.clear?.());

    dispatch(setPriceListItemListFilter({}));
  }, [name, type, dispatch]);

  const handleSubmit = () => {
    dispatch(
      setPriceListItemListFilter({
        name__icontains: name.value,
        type: type.value,
      }),
    );
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='sg-u-vs-2'>
        <FormItem {...name}>
          <Input {...name} />
        </FormItem>
        <FormItem {...type}>
          <Select hasEmptyItem {...type} />
        </FormItem>
      </div>
      <StickyFooter>
        <BtnBar stretch>
          <CtaBtn type='submit'>
            <FormattedMessage {...priceListBtnMessages.filterSubmit} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleClearBtnClick}>
            <FormattedMessage {...priceListBtnMessages.clear} />
          </SecondaryBtn>
        </BtnBar>
      </StickyFooter>
    </Form>
  );
};
